"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
__exportStar(require("./AnalyticsProductItem"), exports);
__exportStar(require("./AnalyticsSales"), exports);
__exportStar(require("./AnalyticsTotals"), exports);
__exportStar(require("./AnalyticsTraffic"), exports);
__exportStar(require("./ApiPriceGet200Response"), exports);
__exportStar(require("./ApiPriceGet422Response"), exports);
__exportStar(require("./ApiStoresGet200Response"), exports);
__exportStar(require("./ApiStoresPostRequest"), exports);
__exportStar(require("./ApiStoresUrlSlugAnalyticsDataGet200Response"), exports);
__exportStar(require("./ApiStoresUrlSlugAnalyticsProductsGet200Response"), exports);
__exportStar(require("./ApiStoresUrlSlugPatchRequest"), exports);
__exportStar(require("./ApiStoresUrlSlugProductsReorderPatchRequest"), exports);
__exportStar(require("./ApiStoresUrlSlugPurchasesCancelPatchRequest"), exports);
__exportStar(require("./ApiStoresUrlSlugPurchasesGet200Response"), exports);
__exportStar(require("./ApiStoresUrlSlugPurchasesUpdatePatchRequest"), exports);
__exportStar(require("./ApiUsersCurrentUserGet200Response"), exports);
__exportStar(require("./Campaign"), exports);
__exportStar(require("./CampaignConfirmation"), exports);
__exportStar(require("./CampaignConfirmationCampaign"), exports);
__exportStar(require("./CampaignConfirmationIndividual"), exports);
__exportStar(require("./CampaignConfirmationOrganizer"), exports);
__exportStar(require("./ConfirmOrder"), exports);
__exportStar(require("./ConfirmOrderCampaign"), exports);
__exportStar(require("./ConfirmOrderOrderInner"), exports);
__exportStar(require("./ConfirmOrderOrderInnerDetails"), exports);
__exportStar(require("./ConfirmOrderOrderInnerName"), exports);
__exportStar(require("./ConfirmOrderOrderInnerStatus"), exports);
__exportStar(require("./ConfirmOrderShipping"), exports);
__exportStar(require("./OrderItem"), exports);
__exportStar(require("./OrderShipment"), exports);
__exportStar(require("./Product"), exports);
__exportStar(require("./ProductCreate"), exports);
__exportStar(require("./ProductCreateVariantsInner"), exports);
__exportStar(require("./ProductUpdate"), exports);
__exportStar(require("./ProductVariantsInner"), exports);
__exportStar(require("./ProductVariantsInnerImagesInner"), exports);
__exportStar(require("./ProductVariantsInnerRgb"), exports);
__exportStar(require("./ProductVariantsInnerTrimRgb"), exports);
__exportStar(require("./ProductsInner"), exports);
__exportStar(require("./ProductsInnerProductCollectionsInner"), exports);
__exportStar(require("./ProductsInnerVariantsInner"), exports);
__exportStar(require("./Purchase"), exports);
__exportStar(require("./PurchasePurchaseItemsSummaryInner"), exports);
__exportStar(require("./PurchaseShippingTo"), exports);
__exportStar(require("./ServiceChargesDetails"), exports);
__exportStar(require("./ShippingAddress"), exports);
__exportStar(require("./SizesInner"), exports);
__exportStar(require("./Store"), exports);
__exportStar(require("./StoreCampaignsInner"), exports);
__exportStar(require("./StoreCreate"), exports);
__exportStar(require("./StoreImport"), exports);
__exportStar(require("./StoreImportCampaignsInner"), exports);
__exportStar(require("./StoreImportOwnerDetail"), exports);
__exportStar(require("./StoreImportStoreConfig"), exports);
__exportStar(require("./StoreImportStoreProductsInner"), exports);
__exportStar(require("./StoreImportStoreProductsInnerVariantsInner"), exports);
__exportStar(require("./StoreSettings"), exports);
__exportStar(require("./StoreUpdate"), exports);
__exportStar(require("./StoresInner"), exports);
__exportStar(require("./StoresInnerProductsInner"), exports);
__exportStar(require("./StoresInnerProductsInnerVariantsInner"), exports);
__exportStar(require("./StoresInnerProductsInnerVariantsInnerImagesInner"), exports);
__exportStar(require("./StoresInnerProductsInnerVariantsInnerRgb"), exports);
__exportStar(require("./StoresInnerProductsInnerVariantsInnerSizesInner"), exports);
__exportStar(require("./StoresInnerProductsInnerVariantsInnerTrimRgb"), exports);
